/**
 * Embed custom "number" fields: browsers keep e/E for scientific notation on paste.
 * Allow optional leading "-", digits, and a single "." — strip everything else.
 */
export function sanitizeEmbedNumberFieldValue(raw) {
    const s = String(raw == null ? '' : raw);
    let sign = '';
    let rest = s;
    if (rest.charAt(0) === '-') {
        sign = '-';
        rest = rest.slice(1);
    }
    rest = rest.replace(/[^\d.]/g, '');
    const parts = rest.split('.');
    if (parts.length <= 1) {
        return sign + rest;
    }
    return sign + parts[0] + '.' + parts.slice(1).join('');
}

/** Vanilla <input type="number"> for embed custom fields */
export function attachEmbedNumberFieldGuards(el) {
    el.addEventListener('keydown', function (ev) {
        if (ev.key === 'e' || ev.key === 'E') {
            ev.preventDefault();
        }
    });
    el.addEventListener('paste', function (ev) {
        ev.preventDefault();
        var text = '';
        try {
            text = (ev.clipboardData || window.clipboardData).getData('text') || '';
        } catch (e) {
            /* ignore */
        }
        var start = el.selectionStart;
        var end = el.selectionEnd;
        if (typeof start !== 'number' || typeof end !== 'number') {
            el.value = sanitizeEmbedNumberFieldValue(text);
            return;
        }
        var merged = el.value.slice(0, start) + text + el.value.slice(end);
        var next = sanitizeEmbedNumberFieldValue(merged);
        el.value = next;
        el.setSelectionRange(next.length, next.length);
    });
    el.addEventListener('input', function () {
        var next = sanitizeEmbedNumberFieldValue(el.value);
        if (next !== el.value) {
            el.value = next;
        }
    });
}
